import styled from 'styled-components'

export const ImagesContainer = styled.div`
  display: grid;
  flex-direction: column;
  gap: 10px;
  grid-template-columns: repeat(2, 1fr);
  max-width: 100%;
  gap: 1rem;
  margin-top: 1rem;
`

export const RemoveImage = styled.button`
  background-color: #FD7477;
  border: none;
  color: white;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  position: absolute;
  top: 10px;
  right: 10px;
  border-radius: 50%;
`

export const ImageContainer = styled.div`
  width: 100%;
  position: relative;
  padding: 1rem;
  border: 1px solid #d1d5db;
  border-radius: 1rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  transition: box-shadow 0.2s ease-in-out;

  &:hover {
    box-shadow: 0 4px 2px -2px #d1d5db;
  }
`

export const Image = styled.img`
  width: 100%;
  height: 15rem;
  border-radius: 1rem;
  object-fit: cover;
  background-color: #F4F4F4;
`

export const ImageInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #6B7280;
  font-weight: 500;
`

export const EditInfosAbout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  color: #6B7280;
  font-weight: 500;
`

export const TitleOrSubtitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  border: 1px solid #d1d5db;
  padding: 0.5rem;
  border-radius: 0.4rem;
  transition: all 0.2s ease-in-out;
  cursor: text;
  
  svg {
    display: none;
  }

  &:hover {
    border-color: #6b7280;
    svg {
      display: block;
    }
  }
`

export const TitleOrSubtitleInput = styled.input`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  border: 1px solid #d1d5db;
  padding: 0.5rem;
  border-radius: 0.4rem;
  outline: none;
  transition: all 0.1s ease-in-out;
  
  &:focus {
    border: 1px solid #0090D3;
  }
`